<template>
  <v-overlay :value="placingOrder" z-index="500">
    <v-snackbar
      :timeout="-1"
      color="blue darken-1"
      :value="true"
      class="placing-order-snackbar mx-auto"
    >
      <div class="py-8 text-center">
        <div v-if="error">
          <h1 class="mb-2">Something went wrong</h1>
          <h3>Please try ordering again.</h3>
        </div>
        <h1 v-else>{{ msg }}</h1>
        <v-progress-circular
          :indeterminate="!error"
          :value="error ? 100 : 0"
          color="white"
          class="my-5"
          width="2"
          size="40"
          ><span :class="['font-italic text-h6 m-icon', { 'has-error': error }]"
            >m</span
          ></v-progress-circular
        >
      </div>
    </v-snackbar>
  </v-overlay>
</template>

<script>
import { mapFields } from 'vuex-map-fields'
export default {
  name: 'DialogPlacingOrder',
  components: {},
  computed: {
    ...mapFields('cart', ['placingOrder']),
  },
  data() {
    return {
      msg: 'Processing your order...',
      textInterval: null,
      numSecondsElapsed: 0,
      error: false,
    }
  },
  methods: {
    cancelTextInterval() {
      if (this.textInterval) {
        clearInterval(this.textInterval)
      }
      this.msg = 'Processing your order...'
    }, // cancelTextInterval
    setTextInterval() {
      this.numSecondsElapsed = 0
      this.error = false
      this.cancelTextInterval()
      this.textInterval = setInterval(() => {
        this.numSecondsElapsed += 5
        switch (this.msg) {
          case 'Processing your order...':
            this.msg = 'Still working...'
            break
          case 'Still working...':
          case 'Finalizing...':
            this.msg = 'Finalizing...'
            break
          default:
            this.msg = 'Processing your order...'
            break
        }
      }, 5000)
    }, // setTextInterval
  },
  watch: {
    placingOrder: {
      handler(show) {
        if (show) {
          this.setTextInterval()
        } else {
          this.cancelTextInterval()
        }
      },
      immediate: true,
    },
    numSecondsElapsed(num) {
      if (num > 15) {
        this.cancelTextInterval()
        this.error = true
        setTimeout(() => {
          this.placingOrder = false
        }, 3000)
      }
    },
  },
}
</script>

<style>
.placing-order-snackbar {
  top: 50%;
  transform: translateY(-50%);
  max-width: 400px;
}
.m-icon {
  opacity: 0.3;
  margin-left: 2px;
  margin-bottom: 3px;
}
.m-icon.has-error {
  opacity: 0.8;
}
</style>
